import {Box,Grid,Button,Paper,MenuItem,TextField,Breadcrumbs,Link,Typography,Menu } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEmployeesList } from "FetchData";
import { useItemSalesReportList } from "api/hooks/reports";
import { useSelector } from "react-redux";
import { useState } from "react";
import moment from "moment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DownloadIcon from "@mui/icons-material/Download";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ItemSalesReportPdf from "scenes/reports/pdfForms/sales/itemSalesReportPdf";
import { currencyFormatter, withoutSymbolFormatter } from "utilities/currencyFormatter";

export default function ItemSalesDetailReport({ setIsSuccess }) {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const user = useSelector((state) => state.authReducer.user);
  const {itemSaleReportList, isLoadingItemSaleReportList, setFilter, setInvoicedBy} = useItemSalesReportList(1, business_branch_id)
  const {employeeList} = useEmployeesList(1, business_branch_id);

  const [openExportOptions, setOpenExportOptions] = useState(false);
  const [anchorE1, setAnchorE1] = useState(null);

  const handleClickOpen = (event) => {
    setAnchorE1(event.currentTarget);
    setOpenExportOptions(true);
  };

  const handleClose = () => {
    setOpenExportOptions(false);
  };

  const handleChangeSupplierFilter = async (e) => {
    setInvoicedBy(e.target.value);
  };

  const [showFiter, setShowFilter] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD HH:mm"));
  const [endDate, setEndDate] = useState(moment().endOf("month").format("YYYY-MM-DD HH:mm"));

  let report_period = startDate + " to " + endDate

  const handleChangePeriodFilter = async (e) => {
    if (e.target.value === "THIS MONTH") {
      setStartDate(moment().startOf("month").format("YYYY-MM-DD HH:mm"));
      setEndDate(moment().endOf("month").format("YYYY-MM-DD HH:mm"));
      setShowFilter(false);
    }
    if (e.target.value === "THIS WEEK") {
      setStartDate(moment().startOf("week").format("YYYY-MM-DD HH:mm"));
      setEndDate(moment().endOf("week").format("YYYY-MM-DD HH:mm"));
      setShowFilter(false);
    }
    if (e.target.value === "TODAY") {
      setStartDate(moment().format("YYYY-MM-DD HH:mm"));
      setEndDate(moment().format("YYYY-MM-DD HH:mm"));
      setShowFilter(false);
    }
    if (e.target.value === "CUSTOM") {
      setShowFilter(true);
    }
  };

  const handleClickFilter = () => {
    setFilter({ start: startDate, end: endDate });
  };

  const columns = [
    { label: "Invoice Date", width: 120 },
    { label: "Item", width: 300 },
    { label: "Description", width: 300 },
    { label: "Quantity Sold", align: "center" },
    { label: "Unit Price", align: "center" },
    { label: "Batch" },
    { label: "Unit" },
    { label: "Total Price", align: "center" },
    { label: "Customer Name" },
    { label: "Invoiced By" },
  ];

  return (
    <Box>
      <Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
          color="inherit"
          onClick={() => navigate("/reports")}
        >
          <AssessmentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Reports
        </Link>
        <Typography
          sx={{ display: "flex", alignItems: "center" }}
          color="text.primary"
        >
          <b>Item Sales Detail Report</b>
        </Typography>
      </Breadcrumbs>
      <Box>
        <Box p="1rem" m="1rem" borderRadius="0.5rem">
          <Grid container spacing={4} className="alignHorizantal">
            <Grid xs={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  // m: "4px",
                }}
              >
                <h4>REPORT PERIOD:</h4>

                <Paper
                  sx={{
                    m: "10px",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 130,
                    maxWidth: 200,
                  }}
                >
                  <TextField
                    label="PERIOD"
                    select
                    defaultValue="THIS MONTH"
                    size="small"
                    onChange={(e) => {
                      handleChangePeriodFilter(e);
                    }}
                    sx={{
                      minWidth: 50,
                      width: "100%",
                      // m: "10px",
                      // backgroundColor: "white",
                    }}
                  >
                    <MenuItem value="TODAY">TODAY</MenuItem>
                    <MenuItem value="THIS WEEK">THIS WEEK</MenuItem>
                    <MenuItem value="THIS MONTH">THIS MONTH</MenuItem>
                    <MenuItem value="CUSTOM">CUSTOM</MenuItem>
                  </TextField>
                </Paper>

                {showFiter ? (
                  <>
                    <Paper
                      sx={{
                        m: "10px",
                        display: "flex",
                        alignItems: "center",
                        minWidth: 130,
                        maxWidth: 200,
                      }}
                    >
                      <TextField
                        label="Start Date"
                        type="datetime-local"
                        defaultValue={startDate}
                        size="small"
                        onChange={(e) => setStartDate(e.target.value)}
                        // sx={{
                        //   m: "10px",
                        //   backgroundColor: "white",
                        // }}
                        inputProps={{
                          max: endDate,
                        }}
                      />
                    </Paper>

                    <Paper
                      sx={{
                        m: "10px",
                        display: "flex",
                        alignItems: "center",
                        minWidth: 130,
                        maxWidth: 200,
                      }}
                    >
                      <TextField
                        label="End Date"
                        type="datetime-local"
                        defaultValue={endDate}
                        size="small"
                        onChange={(e) => setEndDate(e.target.value)}
                        // sx={{
                        //   m: "10px",
                        //   backgroundColor: "white",
                        // }}
                        inputProps={{
                          min: startDate,
                        }}
                      />
                    </Paper>
                  </>
                ) : null}
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    m: "9px",
                  }}
                  onClick={() => handleClickFilter()}
                >
                  FILTER
                </Button>
              </Box>
            </Grid>

            <Grid xs={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  // m: "4px",
                }}
              >
                <h4>FILTER BY EMPLOYEE:</h4>
                <Paper
                  sx={{
                    m: "10px",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 130,
                    maxWidth: 200,
                  }}
                >
                  <TextField
                    label="EMPLOYEES"
                    select
                    defaultValue="all"
                    size="small"
                    onChange={(e) => {
                      handleChangeSupplierFilter(e);
                    }}
                    sx={{
                      minWidth: 50,
                      width: "100%",
                    }}
                  >
                    <MenuItem key={"DEFAULT"} value="all">
                      ALL
                    </MenuItem>
                    {employeeList.map((row, index) => {
                      return (
                        <MenuItem key={index} value={row.id}>
                          {row.first_name} {row.last_name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Paper>
              </Box>
            </Grid>
            <Grid xs={2} sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                anchorE1={anchorE1}
                endIcon={<DownloadIcon />}
              >
                EXPORT
              </Button>
              <Menu
                style={{ marginRight: "30px" }}
                anchorEl={anchorE1}
                open={openExportOptions}
                onClose={handleClose}
              >
                <MenuItem
                  style={{
                    color: "black",
                    margin: "5px 0 5px 0",
                    fontSize: "12px",
                    width: "100px",
                    textWrap: "pretty",
                    borderRadius: "5px",
                  }}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <PDFDownloadLink
                    document={
                      <ItemSalesReportPdf
                        viewData={{
                          report_detail: itemSaleReportList,
                          report_period: report_period,
                        }}
                        printedBy={user.first_name + " " + user.last_name}
                      />
                    }
                    fileName={`Item Sales Detail Report for ${report_period}`}
                  >
                    PDF
                  </PDFDownloadLink>
                </MenuItem>
                <MenuItem
                  style={{
                    color: "black",
                    margin: "5px 0 5px 0",
                    fontSize: "12px",
                    width: "100px",
                    textWrap: "pretty",
                    borderRadius: "5px",
                  }}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  EXCEL
                </MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Box>

        <ReportTable
          columns={columns}
          rows={itemSaleReportList}
          loading={isLoadingItemSaleReportList}
          emptyMessage="No data found"
          renderRow={(row, index) => (
            <RRow key={row.id ?? index} index={index}>
              <RCell>{moment(row.date_created).format("LLL")}</RCell>
              <RCell>{row.related_product.product_name}</RCell>
              <RCell>{row.related_product.description}</RCell>
              <RCell align="center">{row.quantity_as_smallest_unit}</RCell>
              <RCell align="center">{withoutSymbolFormatter(parseFloat(Number(row.sale_price)))}</RCell>
              <RCell>{row.batch}</RCell>
              <RCell>{row.related_product_unit.related_business_product_unit.name}</RCell>
              <RCell align="center">{currencyFormatter(parseFloat(Number(row.total)))}</RCell>
              <RCell>{row.related_invoice.created_by.first_name} {row.related_invoice.created_by.last_name}</RCell>
              <RCell>{row.related_invoice.created_by.first_name} {row.related_invoice.created_by.last_name}</RCell>
            </RRow>
          )}
        />
      </Box>
    </Box>
  );
}
